import { Theme } from '@nexelem/deprecated-theme';

export const getScroll = (theme: Theme) => {
  const {
    palette: { getColor },
    client: { table },
    spacing,
  } = theme;
  return {
    '&.MuiDataGrid-root': {
      border: 'none',
    },
    '.MuiDataGrid-main': {
      paddingBottom: spacing(4), // Add space for Y scrollBar
      '& > div:first-child:not(.MuiDataGrid-columnHeaders)': {
        backgroundColor: getColor(table.common.backgroundColor),
      },
      '.MuiDataGrid-filler': {
        display: 'none',
      },
    },
  };
};
